module.exports = __webpack_public_path__ + "img/844-4228ba.png";